import { ObjectId } from "mongodb";
import { RouterData } from "../entity/router/RouterData";

export interface RouterGroup {
  iccid?: string,
  imei: string,
  data: RouterData[]
}

export interface RouterReading {
  timestamp:Date,
  signalDbm:string,
  network:string,
  plmn:string,
  lac:string,
  cellId:string
}

export interface RouterReadings {
  _id?: ObjectId|null
  readings: RouterReading[]
}

export interface RouterDevice {
  _id?: ObjectId|null
  imei:string,
  iccid:string,
  clientId?:number|null,
  ipAddress?:string|null,
  latitude?:number|null,
  longitude?:number|null,
  signalDbm:string,
  plmn:string,
  lac:string,
  readings:ObjectId|null
  lastCallback:Date
}